export default function AuthGate({ children, session }) {
  // Если сессия не определена или не содержит access_token, ничего не показываем
  // (родительский компонент покажет свой загрузчик)
  if (!session || !session.access_token) {
    return null;
  }

  return children;
}
